define("shared/components/shared/social/instagram-modal", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _isPageDisabled;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{this.closeModal}} @focusTrap={{true}} {{track "connected-facebook-credentials"}} as |modal|>
    <modal.card class="o--modalCard--narrow">
      <modal.card-header>
        <h2 class="o--modalHeader__title">
          {{t "credentials.instagram_modal.header.title"}}
        </h2>
      </modal.card-header>
      <modal.card-body class="u--p__t__0 u--p__b__sm">
        {{#if this.isFetchingPages}}
          <div class="o--blank u--p__tb__lg">
            <Shared::LoadingSpinner />
          </div>
        {{else if this.showPageSelector}}
          <p class="u--m__b">{{html-safe (t "credentials.instagram_modal.body.linked_profiles")}}</p>
          <ul class="u--listUnstyle">
            {{#each this.availablePages as |page|}}
              <Shared::Social::InstagramModal::AvailablePage
                @isRunning={{this.isAddingPage}}
                @page={{page}}
                @selectPage={{this.selectPage}}
                @selectedPage={{this.selectedPage}}
              />
            {{/each}}
          </ul>
          {{#if this.unavailablePages.length}}
            <Shared::CollapsableInfoCard
              @hideOnInit={{this.hideOnInit}}
              @title={{t "credentials.instagram_modal.body.unavailable.title" count=this.unavailablePages.length}}
              class="u--text--light"
            >
              <ul class="u--listUnstyle">
                {{#each this.unavailablePages as |page|}}
                  <Shared::Social::InstagramModal::UnavailablePage
                    @page={{page}}
                    @unavailableReason={{this.unavailableReason}}
                  />
                {{/each}}
              </ul>
            </Shared::CollapsableInfoCard>
          {{/if}}
        {{else}}
          <div class="o--blank u--p__0 u--p__b__lg">
            <div class="img--empty__labels"></div>
            <p class="o--blank__desc u--m__t">
              {{t "credentials.instagram_modal.body.no_profiles_available"}}
            </p>
          </div>
        {{/if}}
        <p class="u--m__t__md">{{html-safe (t "credentials.instagram_modal.body.login_info")}}</p>
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button
          @onClick={{this.closeModal}}
          @text={{t "shared_words.back"}}
          @variant="outline"
          class="u--float--left"
        />
        <Shared::Ui::Button
          @isDisabled={{this.buttonIsDisabled}}
          @promise={{task this.addPage this.selectedPage}}
          @text={{if
            this.isAddingPage
            (t "credentials.instagram_modal.footer.connecting_profile")
            (t "credentials.instagram_modal.footer.connect_profile")
          }}
          @variant="primary"
          class="u--float--right"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "fW9fwnHH",
    "block": "[[[8,[39,0],[[4,[38,1],[\"connected-facebook-credentials\"],null]],[[\"@close\",\"@focusTrap\"],[[30,0,[\"closeModal\"]],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[24,0,\"o--modalCard--narrow\"]],null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"credentials.instagram_modal.header.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0 u--p__b__sm\"]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"isFetchingPages\"]],[[[1,\"        \"],[10,0],[14,0,\"o--blank u--p__tb__lg\"],[12],[1,\"\\n          \"],[8,[39,4],null,null,null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showPageSelector\"]],[[[1,\"        \"],[10,2],[14,0,\"u--m__b\"],[12],[1,[28,[35,5],[[28,[37,2],[\"credentials.instagram_modal.body.linked_profiles\"],null]],null]],[13],[1,\"\\n        \"],[10,\"ul\"],[14,0,\"u--listUnstyle\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"availablePages\"]]],null]],null],null,[[[1,\"            \"],[8,[39,8],null,[[\"@isRunning\",\"@page\",\"@selectPage\",\"@selectedPage\"],[[30,0,[\"isAddingPage\"]],[30,2],[30,0,[\"selectPage\"]],[30,0,[\"selectedPage\"]]]],null],[1,\"\\n\"]],[2]],null],[1,\"        \"],[13],[1,\"\\n\"],[41,[30,0,[\"unavailablePages\",\"length\"]],[[[1,\"          \"],[8,[39,9],[[24,0,\"u--text--light\"]],[[\"@hideOnInit\",\"@title\"],[[30,0,[\"hideOnInit\"]],[28,[37,2],[\"credentials.instagram_modal.body.unavailable.title\"],[[\"count\"],[[30,0,[\"unavailablePages\",\"length\"]]]]]]],[[\"default\"],[[[[1,\"\\n            \"],[10,\"ul\"],[14,0,\"u--listUnstyle\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"unavailablePages\"]]],null]],null],null,[[[1,\"                \"],[8,[39,10],null,[[\"@page\",\"@unavailableReason\"],[[30,3],[30,0,[\"unavailableReason\"]]]],null],[1,\"\\n\"]],[3]],null],[1,\"            \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]],null]],[]],[[[1,\"        \"],[10,0],[14,0,\"o--blank u--p__0 u--p__b__lg\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"img--empty__labels\"],[12],[13],[1,\"\\n          \"],[10,2],[14,0,\"o--blank__desc u--m__t\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"credentials.instagram_modal.body.no_profiles_available\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]],[]]],[1,\"      \"],[10,2],[14,0,\"u--m__t__md\"],[12],[1,[28,[35,5],[[28,[37,2],[\"credentials.instagram_modal.body.login_info\"],null]],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,11],[[24,0,\"u--float--left\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"closeModal\"]],[28,[37,2],[\"shared_words.back\"],null],\"outline\"]],null],[1,\"\\n      \"],[8,[39,11],[[24,0,\"u--float--right\"]],[[\"@isDisabled\",\"@promise\",\"@text\",\"@variant\"],[[30,0,[\"buttonIsDisabled\"]],[28,[37,12],[[30,0,[\"addPage\"]],[30,0,[\"selectedPage\"]]],null],[52,[30,0,[\"isAddingPage\"]],[28,[37,2],[\"credentials.instagram_modal.footer.connecting_profile\"],null],[28,[37,2],[\"credentials.instagram_modal.footer.connect_profile\"],null]],\"primary\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"page\",\"page\"],false,[\"shared/modal\",\"track\",\"t\",\"if\",\"shared/loading-spinner\",\"html-safe\",\"each\",\"-track-array\",\"shared/social/instagram-modal/available-page\",\"shared/collapsable-info-card\",\"shared/social/instagram-modal/unavailable-page\",\"shared/ui/button\",\"task\"]]",
    "moduleName": "shared/components/shared/social/instagram-modal.hbs",
    "isStrictMode": false
  });
  let InstagramModalComponent = _exports.default = (_dec = (0, _service.inject)('social/instagram-auth'), (_class = (_isPageDisabled = /*#__PURE__*/new WeakSet(), class InstagramModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _isPageDisabled);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "instagramAuth", _descriptor4, this);
      _initializerDefineProperty(this, "intl", _descriptor5, this);
      _initializerDefineProperty(this, "isAddingPage", _descriptor6, this);
      _initializerDefineProperty(this, "selectedPage", _descriptor7, this);
      _defineProperty(this, "addPage", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (!this.selectedPage) {
            return;
          }
          try {
            this.isAddingPage = true;
            yield this.instagramAuth.createInstagramProfile.perform(this.selectedPage);
            this.isAddingPage = false;
            this.closeModal();
          } catch (error) {
            this.isAddingPage = false;
            this.alerts.warning(this.intl.t('alerts.account.controllers.groups.facebook.add_error'));
            this.errors.log(error, {
              page: JSON.stringify(this.selectedPage)
            });
          }
        }
      }), null, "addPage", "drop"));
    }
    get isFetchingPages() {
      return this.instagramAuth.authenticateWithFacebookGraphApi.isRunning;
    }
    get buttonIsDisabled() {
      return !this.selectedPage || this.addPage.isRunning;
    }
    get availablePages() {
      return this.instagramAuth.facebookPages?.filter(facebookPage => !_classPrivateMethodGet(this, _isPageDisabled, _isPageDisabled2).call(this, facebookPage)).sortBy('instagram_business_account.username');
    }
    get unavailablePages() {
      return this.instagramAuth.facebookPages?.filter(facebookPage => _classPrivateMethodGet(this, _isPageDisabled, _isPageDisabled2).call(this, facebookPage)).sortBy('name');
    }
    get showPageSelector() {
      return Boolean(this.availablePages?.length) || Boolean(this.unavailablePages?.length);
    }
    get hideOnInit() {
      return Boolean(this.availablePages?.length);
    }
    hasInstagramProfile(page) {
      return Boolean(page.instagram_business_account);
    }
    hasRequiredTasks(page) {
      if (!page.tasks) {
        return false;
      }
      const requiredTasks = ['ADVERTISE', 'ANALYZE', 'MODERATE', 'CREATE_CONTENT'];
      return requiredTasks.every(requiredTask => page.tasks.includes(requiredTask));
    }
    isProfileAlreadyConnected(page) {
      return Boolean(this.auth.currentGroup?.socialProfiles?.filter(socialProfile => socialProfile.isInstagram && socialProfile.nickname === page.instagram_business_account?.username && !socialProfile.isNew).length);
    }
    unavailableReason(page) {
      if (this.isProfileAlreadyConnected(page)) {
        return this.intl.t('credentials.instagram_modal.body.unavailable.already_connected');
      }
      if (!this.hasInstagramProfile(page)) {
        return this.intl.t('credentials.instagram_modal.body.unavailable.no_ig_connected');
      }
      return this.intl.t('credentials.instagram_modal.body.unavailable.no_permission');
    }
    selectPage(page) {
      if (this.selectedPage?.id === page.id) {
        this.selectedPage = undefined;
      } else {
        this.selectedPage = page;
      }
    }
    closeModal() {
      this.instagramAuth.closeInstagramModal();
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "instagramAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isAddingPage", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "selectedPage", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "unavailableReason", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "unavailableReason"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectPage", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class));
  function _isPageDisabled2(page) {
    return this.isProfileAlreadyConnected(page) || !this.hasInstagramProfile(page) || !this.hasRequiredTasks(page);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, InstagramModalComponent);
});